import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  constructor(private router: Router) {}

  canActivate(): boolean {
      let isLoggedIn = sessionStorage.getItem("accessToken");
      if(isLoggedIn) {
        return true
      }
      const currentUrl = window.location.pathname + window.location.search;
      this.router.navigate(['/login']);
      return false;
  }
  canDeactivate(): boolean {
    let isLoggedIn = sessionStorage.getItem("accessToken");
      if(isLoggedIn) {
        this.router.navigate(['/home']);
        return false;
        
      }  
      return true;
  }
}

export const AuthGuard: CanActivateFn = (): boolean => {
  return inject(AuthguardService).canActivate();
}

export const routeGuard: CanActivateFn = (): boolean => {
  return inject(AuthguardService).canDeactivate();
}
